import { apiGet} from '../standardApi';

export async function apiGetHealthService () {
  const response = await apiGet(`/HealthToken/GenerateTokenSanteClair`, 'application/json');
  return response;
}
